const DAY_MS = 24 * 60 * 60 * 1000;

const termKey = (lesson) => String(lesson?.termId?._id || lesson?.termId || '');

// Classes meet weekly, so a gap of more than 7 days between consecutive
// lessons means a half-term / holiday; a termId change means a new term.
export const isBreakBefore = (prev, lesson) => {
    if (!prev) return false;
    if (termKey(prev) && termKey(lesson) && termKey(prev) !== termKey(lesson)) return true;
    return Math.round((new Date(lesson.date) - new Date(prev.date)) / DAY_MS) > 7;
};
